import { render, staticRenderFns } from "./UsageRecording.vue?vue&type=template&id=8f25a4d2&scoped=true"
import script from "./UsageRecording.vue?vue&type=script&lang=js"
export * from "./UsageRecording.vue?vue&type=script&lang=js"
import style0 from "./UsageRecording.vue?vue&type=style&index=0&id=8f25a4d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f25a4d2",
  null
  
)

export default component.exports